/*
 * @Author: wufan 
 * @Date: 2019-08-19 14:10:17 
 * @Last Modified by: wufan
 * @Last Modified time: 2019-10-08 18:32:31
 * 帮助中心-展示二级菜单目录列表
 */

import React, { useEffect, useState } from 'react';
import './SearchResultPage.less';
import AxiosTS from '../../core/axios';
import {
  withRouter
} from 'react-router-dom';
import './SubMenuListPage.less';
import FirstEnterPage from './FirstEnterPage';
import XMTD from '../../core/xmTD';

const SubMenuListPage: React.FC = (props: any) => {
  const searchKey = props.location.pathname.indexOf('/', 5) !== -1 ? props.location.pathname.slice(props.location.pathname.indexOf('/', 5) + 1) : "";

  const [subMenuData, setSubMenuData] = useState([]);
  const [subMenuTotal, setSubMenuTotal] = useState(-1);// 获取SubMenu 菜单项数据总条数
  const [subMenuPageNo, setSubMenuPageNo] = useState(1);
  let newVersion = localStorage.getItem('newVersion');

  // 路由id改变重置状态
  useEffect(() => {
    setSubMenuData([]);
    setSubMenuTotal(-1);
    setSubMenuPageNo(1);
    // 将b端账户信息存入localStorage
    props.history.location.pathname == "/entry" && decodeUrlParam();
  }, [searchKey])


  // 分页多次请求数据
  useEffect(() => {
    // 当data的长度与总长度不相等且有id，则请求数据
    subMenuData.length !== subMenuTotal && searchKey &&
      AxiosTS.sobot("search_doc_list", {
        questionTypeId: searchKey,
        robotFlag: newVersion == 'true' ? 2 : 1,
        keyFlag: 1,
        pageNo: subMenuPageNo,
        usedFlag: 0// 默认启用状态
      })
        .then((res: any) => {
          if (res.code === "1000") {
            let data: never[] = subMenuData.concat(res.data.items);
            let sortList: never[] = sortData(data);
            setSubMenuData(sortList);
            setSubMenuTotal(res.data.totalCount);
            setSubMenuPageNo(preNo => preNo + 1);
          }
        })
  }, [searchKey, subMenuPageNo, newVersion])

  // 按数字序号从小到大排序
  function sortData(arr: never[]) {

    let newArr = arr.sort((a: { questionTitle: string }, b: { questionTitle: string }): any => {
      let AQuestionTitle = a.questionTitle;
      let BQuestionTitle = b.questionTitle;
      let firstNumbers = AQuestionTitle.slice(0, AQuestionTitle.indexOf("#"));
      let secondNumbers = BQuestionTitle.slice(0, BQuestionTitle.indexOf("#"));
      return Number(firstNumbers) - Number(secondNumbers)
    })
    return newArr;
  }

  // 获取title
  let item: { questionTypeName: string } = subMenuData.length !== 0 ? subMenuData[0] : { questionTypeName: "" };

  function changeRouter(docId: string) {
    props.history.push({
      pathname: `/detail/${docId}`,
      params: {
        docId: docId
      }
    })
  }
  function decodeUrlParam() {
    let url = props.history.location;
    let params = url.search.slice(1).split("&");
    let paramList: any = {}
    params.forEach((item: any) => {
      const key: string = (item.split("=")[0]);
      paramList[key] = decodeURIComponent(item.split("=")[1]);
    })
    let newVersion = paramList.newVersion;
    localStorage.setItem('newVersion', newVersion);
    localStorage.setItem("urlFromB", url);
    localStorage.setItem("ParamsFromB", JSON.stringify(paramList));

    // 设置智齿客服用户自定义参数
    zhiManagerSetUserParams()


  }

  function zhiManagerSetUserParams() {
    let paramList: any = JSON.parse(localStorage.getItem("ParamsFromB") || "");
    try {
      if (window.zhiManager) {
        window.zhiManager.set('userinfo', {
          uname: paramList.instName + '-' + paramList.adminName,   //昵称
          face: paramList.banner,   //头像URL
          realname: paramList.adminName,   //真实姓名
          partnerId: paramList.instId
        });
      }
    }
    catch (err) {
      //在这里处理错误
    }
  }

  function XMDataDot(item: any) {
    let paramList: any = JSON.parse(localStorage.getItem("ParamsFromB") || "");
    paramList.name = "B端-点击-帮助中心详情";
    paramList.docId = item.docId;
    paramList.questionTitle = item.questionTitle;
    XMTD(paramList);
  }

  return (
    <div className="sub-menu-list-page">
      {
        props.location.pathname === '/entry' ? <FirstEnterPage /> :
          <div className="hasId">
            <div className="sub-menu-title">
              {item.questionTypeName}
              {/* 基础配置 */}
            </div>
            <ul className="sub-menu-list">
              {subMenuData.map((item: any, index: number) => {
                return <li className="sub-menu-item" key={item.docId} onClick={() => {
                  changeRouter(item.docId);
                  XMDataDot(item);
                }
                }>{item.questionTitle}</li>
              })}
            </ul>
          </div>
      }

    </div>
  )
}

export default withRouter(SubMenuListPage);